import React from "react";
import LanguageSelector from "../language-selector/LanguageSelector";
import { MobileMenu } from "../mobile/mobile.menu";

const AppBarForLogin = (props) => {

    const { options, userData } = props;

    return (
        <div className="w-full h-16 fixed top-0 left-0 z-30 bg-white flex justify-between items-center border-b-[1px]">
            {((userData && userData.roles !== "CLIENT")||(userData && userData.profile !== null && userData.profile.consent === true)) && (
                <MobileMenu options={options} />
            )}
            <LanguageSelector isLogined={props.isLogined} userData={props.userData} />
        </div>
    )
}
export default AppBarForLogin
